"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverOrientering = void 0;
/* eslint-disable jsx-a11y/no-static-element-interactions */
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("nav-frontend-popover-style");
// tslint:disable-next-line:max-line-length
var PopoverOrientering;
(function (PopoverOrientering) {
    PopoverOrientering["Over"] = "over";
    PopoverOrientering["OverVenstre"] = "over-venstre";
    PopoverOrientering["OverHoyre"] = "over-hoyre";
    PopoverOrientering["Under"] = "under";
    PopoverOrientering["UnderVenstre"] = "under-venstre";
    PopoverOrientering["UnderHoyre"] = "under-hoyre";
    PopoverOrientering["Venstre"] = "venstre";
    PopoverOrientering["Hoyre"] = "hoyre";
})(PopoverOrientering = exports.PopoverOrientering || (exports.PopoverOrientering = {}));
const cls = (props) => (0, classnames_1.default)("popover", props.className, {
    "popover--over": [
        PopoverOrientering.Over,
        PopoverOrientering.OverVenstre,
        PopoverOrientering.OverHoyre,
    ].indexOf(props.orientering) !== -1,
    "popover--under": [
        PopoverOrientering.Under,
        PopoverOrientering.UnderVenstre,
        PopoverOrientering.UnderHoyre,
    ].indexOf(props.orientering) !== -1,
    "popover--venstre": props.orientering === PopoverOrientering.Venstre,
    "popover--hoyre": props.orientering === PopoverOrientering.Hoyre,
    "popover--uten-pil": props.utenPil,
});
class PopoverBase extends React.PureComponent {
    render() {
        const _a = this.props, { children, className, posisjon, orientering, utenPil, innerRef } = _a, rest = __rest(_a, ["children", "className", "posisjon", "orientering", "utenPil", "innerRef"]);
        const stiler = {
            transform: `translate3d(${posisjon.left}px, ${posisjon.top}px, 0)`,
        };
        let pilStiler;
        if ([PopoverOrientering.Hoyre, PopoverOrientering.Venstre].indexOf(this.props.orientering) === -1) {
            pilStiler = { left: this.props.posisjon.pilLeft };
        }
        return (React.createElement("div", Object.assign({ className: cls(this.props), style: stiler, onClick: (e) => e.stopPropagation(), ref: innerRef }, rest),
            React.createElement("div", { className: "popover__content-inner" }, children),
            !this.props.utenPil && (React.createElement("span", { className: "popover__pil", style: pilStiler }))));
    }
}
PopoverBase.defaultProps = {
    orientering: PopoverOrientering.Over,
    posisjon: {
        left: 0,
        top: 0,
    },
};
exports.default = PopoverBase;
